import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {createEvent} from "../misc/event.polyfill";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {ListEditorService} from "./list-editor.service";

@Component({
  selector: "list-display",
  templateUrl: "./list-display.template.pug",
})
export class ListDisplayComponent implements OnInit, OnChanges {
  public listStructure: any;

  @Input("listStructure")
  _listStructure: any;

  @Output("onChange")
  public onChangeEmitter: any = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
    if (changes["_listStructure"]) {
      this.listStructure = changes["_listStructure"].currentValue;
    }
  }

  ngOnInit() {
    this.ngOnChanges({});
  }

  change(key, value) {
    const event = createEvent("change");
    event["key"] = key;
    event["value"] = value;
    this.onChangeEmitter.emit(event);
  }

  constructor(
    public dialogService: DialogService,
    private listEditorService: ListEditorService,
  ) {
  }
}
